import { Vector3 } from "three";

import Element from "./element";

export default class Desktop extends Element {
	width: number;
	height: number;
	depth: number;
	topHeight: number;
	footWidth: number;

	constructor({
		id,
		color,
		width,
		height,
		depth,
		topHeight,
		footWidth
	}: {
		id: string;
		color: string;
		width: number;
		height: number;
		depth: number;
		topHeight: number;
		footWidth: number;
	}) {
		super({ id, color, type: "desktop" });
		this.width = width;
		this.height = height;
		this.depth = depth;
		this.topHeight = topHeight;
		this.footWidth = footWidth;
	}
	getParts() {
		const footXPos = (this.width - this.footWidth) / 2;
		const footYPos = -this.topHeight / 2;
		const dimensions: Vector = [this.footWidth, this.height - this.topHeight, this.depth];

		const res: PartDefinition[] = [];
		// Top of the table:
		res.push({
			position: new Vector3(0, (this.height - this.topHeight) / 2, 0),
			dimensions: [this.width, this.topHeight, this.depth]
		});
		// left foot
		res.push({ position: new Vector3(-footXPos, footYPos, 0), dimensions });
		// right foot
		res.push({ position: new Vector3(footXPos, footYPos, 0), dimensions });
		return res;
	}
	getBoundingBox() {
		return [this.width, this.height, this.depth] as Vector;
	}
	showInfos() {
		return `${this.type}: (${this.width}, ${this.height}, ${this.depth}) top=${this.topHeight} foot=${this.footWidth}`;
	}
	cloneUpdate(name: string, value: string | number) {
		return new Desktop({ ...this, [name]: value });
	}
	cloneWithZoom(zoom: number) {
		return new Desktop({
			id: this.id,
			color: this.color,
			width: this.width * zoom,
			height: this.height * zoom,
			depth: this.depth * zoom,
			topHeight: this.topHeight * zoom,
			footWidth: this.footWidth * zoom
		});
	}
	toJson() {
		const { id, color, type, width, height, depth, topHeight, footWidth } = this;
		return { id, color, type, props: { width, height, depth, topHeight, footWidth } };
	}
}
